import utilities from '@/helpers/utilities';
import constants from '@/helpers/constants';

export function dateToShortString(value) {
    if (utilities.isEmpty(value)) return value;

    const date = typeof value === 'string' ? new Date(value) : value;

    return date.toLocaleDateString('pt-BR');
}

export function dateToLongString(value) {
    if (utilities.isEmpty(value)) return value;

    const date = typeof value === 'string' ? new Date(value) : value;

    return date.toLocaleString('pt-BR');
}

export function personToString(value) {
    if (utilities.isEmpty(value)) return '-';

    const name = value.name;
    const username = value.username;
    return `${username} - ${name}`;
}

export function areaToString(value) {
    if (utilities.isEmpty(value)) return '-';

    return value.acronym;
}

export function shortenedDescription(text) {
    if (text.length < 90) return text;

    return `${text.substring(0, 90)}...`;
}

export function demandOwner(demand) {
    return demand.status.id < constants.STATUS_REJECTED ? demand.owner.name : '';
}



// WEBPACK FOOTER //
// ./src/helpers/filters.js